import React from 'react';
import Logo from '../images/icons/footerLogo.svg'
import ig from '../images/icons/ig.svg'
import x from '../images/icons/x.svg'
import tiktok from '../images/icons/tiktok.svg'
import fb from '../images/icons/fb.svg'
import linkedin from '../images/icons/linkedin.svg'
import youtube from '../images/icons/youtube.svg'
import location from '../images/icons/location.svg'
import phone from '../images/icons/phone.svg'
import email from '../images/icons/email.svg'
import dot from '../images/icons/dot.svg'
import { Link } from 'react-router-dom';

function Footer(props) {
    return (
        <div className='px-5 lg:px-20 mb-5 lg:mb-10'>
            <div className='bg-[#000000] rounded-[8px] items-center'>
                <div className='flex flex-col lg:flex-row lg:space-x-20 p-3 space-y-6 lg:space-y-0 lg:p-5 lg:py-10 xl:pb-20 lg:items-center'>
                    <div className='flex flex-col text-white text-start space-y-10 lg:w-[50%]'>
                        <div className=''><img className='h-10 w-auto' src={Logo} alt="Yebokenny" /></div>
                        <div className='text-[24px] lg:text-[32px] leading-[31px] lg:leading-[41.92px]'>Offering you the best recommendation system digitally</div>
                        <div className='flex flex-row space-x-3'>
                            <a className="transition hover:opacity-70" href="https://www.instagram.com/yebokenny_app" aria-label="Instagram"><img src={ig} alt="" /></a>
                            <a className="transition hover:opacity-70" href="https://x.com/YeboKenny" aria-label="X"><img src={x} alt="" /></a>
                            <a className="transition hover:opacity-70" href="https://www.tiktok.com/@yebokenny3" aria-label="TikTok"><img src={tiktok} alt="" /></a>
                            <a className="transition hover:opacity-70" href="https://www.facebook.com/yebokenny/" aria-label="Facebook"><img src={fb} alt="" /></a>
                            <a className="transition hover:opacity-70" href="https://www.linkedin.com/in/yebokenny-app-b018b3268/" aria-label="LinkedIn"><img src={linkedin} alt="" /></a>
                            <a className="transition hover:opacity-70" href="https://www.youtube.com/@Yebokenny" aria-label="YouTube"><img src={youtube} alt="" /></a>
                        </div>
                    </div>
                    <div className='flex flex-col text-white lg:space-y-2'>
                        <div className='font-[500] mb-4 text-start'>Quick Links</div>
                        <div className='flex flex-col text-start font-[400] opacity-75'>
                            <ul className='flex flex-col space-y-4'>
                                <Link to='/faqs'>Faqs</Link>
                                <Link to='/blogs'>Blogs</Link>
                                <Link to='/pricing'>Pricing</Link>
                                <Link to='/about'>About Us</Link>
                                <Link to='/contact'>Contact Us</Link>
                                <Link to='/partner-with-us'>Partner With Us</Link>
                            </ul>
                        </div>
                    </div>
                    <div className='flex flex-col text-white space-y-2'>
                        <div className='font-[500] text-start mb-4'>Contact</div>
                        <div className='flex flex-col text-start font-[400] opacity-75'>
                            <ul className='flex flex-col space-y-4'>
                                <span className='flex flex-row space-x-2'>
                                    <span><img src={location} /></span>
                                    {sessionStorage.getItem('userCountry') == 'Nigeria' ? 
                                    <span>Abuja, Nigeria</span>
                                    :
                                    <span className=''>
                                        Pietermaritzburg, SA
                                    </span>
                                    }
                                </span>
                                <span className='flex flex-row space-x-2'>
                                    <span><img src={phone} /></span>
                                    <span>
                                        {sessionStorage.getItem('userCountry') == 'Nigeria' ? 
                                            <a className='underline' href='https://wa.me/+2347045857020'>+2347045857020(Nigeria)</a>
                                            :
                                            <a className='underline' href='https://wa.me/+27608884453'>+27608884453, +27333442001(SA)</a>
                                        }
                                    </span>
                                </span>

                                
                                <span className='flex flex-row space-x-2'>
                                    <span><img src={email} /></span>
                                    <span><a className='underline' href='mailto:business@yebokenny.com'>business@yebokenny.com</a></span>
                                </span>
                                <span className='flex flex-row space-x-2'>
                                    <span><img src={phone} alt="" /></span>
                                    <span><a className='underline' href='tel:+27334920174'>+27 33 492 0174</a></span>
                                </span>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='pb-5 px-5 xl:mt-10'>
                    <hr className='h-[1px]'></hr>
                </div>
                <div className='px-5 flex flex-col lg:flex-row text-start justify-between space-y-3 lg:space-y-0 text-white lg:items-center pt-2 pb-10 '>
                    <span className='xl:pb-4 opacity-75'>©YeboKenny. Positive Referencing for Business Excellence</span>
                    <div className='flex flex-row space-x-3 items-center xl:pb-4 opacity-75'>
                        <Link to='/privacy-policy'>Privacy Policy</Link>
                        <span><img src={dot} /></span>
                        <Link to='/terms-and-conditions'>Terms and Conditions</Link>
                        <span><img src={dot} /></span>
                        <Link to='/cookies-policy'>Cookies Policy</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;